import type { CountryInterface } from './geo'
import type { Media } from './media'
import type { OptionInterface } from '~/components/base/controls/use-simple-input'

export enum CompanySponsorType {
  Bronze = 1,
  Silver,
  Gold,
  Platinum,
  Organizer,
  General,
  Diamond,
  Sponsor,
  Partner,
  Media,
}

export const SPONSOR_TYPE_OPTIONS: OptionInterface[] = [
  {
    value: 0,
    label: '—',
  },
  {
    value: CompanySponsorType.Bronze,
    label: 'Bronze Sponsor',
  },
  {
    value: CompanySponsorType.Silver,
    label: 'Silver Sponsor',
  },
  {
    value: CompanySponsorType.Gold,
    label: 'Gold Sponsor',
  },
  {
    value: CompanySponsorType.Platinum,
    label: 'Platinum Sponsor',
  },
  {
    value: CompanySponsorType.Organizer,
    label: 'Organizer',
  },
  {
    value: CompanySponsorType.General,
    label: 'General Sponsor',
  },
  {
    value: CompanySponsorType.Diamond,
    label: 'Diamond Sponsor',
  },
  {
    value: CompanySponsorType.Sponsor,
    label: 'Sponsor',
  },
  {
    value: CompanySponsorType.Partner,
    label: 'Partner',
  },
  {
    value: CompanySponsorType.Media,
    label: 'Media',
  },
]

export interface CompanyLite {
  id: number
  logo: string | null
  name: string
}

export interface Company {
  id: number
  name: string
  description: string | null
  logo: Media | null
  cover: Media | null
  size: number | null
  site: string | null
  geo: string | null
  email: string | null
  media: Media[]
  business: { id: number; name: string }[]
  tags: number[]
  country: CountryInterface | null
  has_chat: boolean
  sponsor_type: number
}

export interface CompanyCreate {
  name: string
  description?: string | null
  size?: number | null
  site?: string | null
  geo?: string | null
  email?: string | null
  business?: number[]
  tags?: number[]
}

export interface CompanyUpdate extends Partial<CompanyCreate> {}
